import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styles from './SelectCategory.styles';


const SelectWrapper = styled.div`${Styles.selectWrapper};`; // prettier-ignore
const Select = styled.select`${Styles.select};`; // prettier-ignore
const SelectArrow = styled.div`${Styles.selectArrow};`; // prettier-ignore

/**
 * Creates a new select
 * @param {Array} options Select options
 * @param {*} selected value of the currently selected option
 * @param {Object} placeholder object to show a placeholder value
 * @returns {JSX}
 */
const SelectCategory = (
  {
    options,
    selected,
    placeholder,
    onChange
  }
) => {
  const optionsArray = [...options];
  if (placeholder !== null) {
    optionsArray.unshift(placeholder);
  }

  return (
    <SelectWrapper>
      <Select defaultValue={selected} onChange={onChange}>
        {optionsArray.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <SelectArrow isMobile={false} />
    </SelectWrapper>
  );
};

SelectCategory.protoTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ),
  selected: PropTypes.any,
  placeholder: PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string
  })
};
SelectCategory.defaultProps = {
  selected: null,
  placeholder: null
};

export default SelectCategory;
